import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ColumnControls from './ColumnControls';
import ColumnItems from './ColumnItems/ColumnItems';
import ColumnHighlighter from './ColumnHighlighter';
import * as selectedElementsActions from '../../../../actions/selectedElements';
import * as columnActions from '../../../../actions/column';
import { columnType } from '../../../../types';

class Column extends PureComponent {
    render() {
        const {
            blockIndex,
            canSplitColumn,
            column,
            columnWidth,
            structureLocked,
            prevColumnIdx,
            nextColumnIdx,
            canvasBlocks,
            dispatch,
            selectedBlocks,
        } = this.props;
        const { columnIdx, columnItems } = column;
        const previousActionValid = typeof prevColumnIdx === 'number' && prevColumnIdx >= 0;
        const nextActionValid = typeof nextColumnIdx === 'number' && nextColumnIdx >= 0;
        const block = canvasBlocks.filter((b) => b.index === blockIndex)[0];
        const isImportContentBlock = block.title === 'Staffbase News';
        const isTableBlock = block.title === 'Table';
        const isSelected = selectedBlocks.includes(blockIndex);
        const shouldRenderColumnControls = !isImportContentBlock && !isTableBlock && !structureLocked && isSelected;

        return (
            <div style={{ width: columnWidth }}>
                <div style={{ width: columnWidth }}>
                    <ColumnHighlighter shouldRender={shouldRenderColumnControls} />
                    <ColumnItems
                        blockIndex={blockIndex}
                        columnIdx={columnIdx}
                        structureLocked={structureLocked}
                        columnItems={columnItems}
                        width={columnWidth}
                        dispatch={dispatch}
                    />
                </div>
                {shouldRenderColumnControls && (
                    <ColumnControls
                        blockIndex={blockIndex}
                        columnIdx={columnIdx}
                        previousActionValid={previousActionValid}
                        nextActionValid={nextActionValid}
                        canSplitColumn={canSplitColumn}
                        removeAllSelectedElements={() => dispatch(selectedElementsActions.removeAllSelectedElements())}
                        mergeColumn={(data) => dispatch(columnActions.mergeColumn(data))}
                        moveColumn={(data) => dispatch(columnActions.moveColumn(data))}
                        splitColumn={(data) => dispatch(columnActions.splitColumn(data))}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedBlocks: state.selectedBlocks,
});

Column.propTypes = {
    blockIndex: PropTypes.string.isRequired,
    canSplitColumn: PropTypes.bool.isRequired,
    column: columnType.isRequired,
    columnWidth: PropTypes.number.isRequired,
    structureLocked: PropTypes.bool.isRequired,
    prevColumnIdx: PropTypes.number.isRequired,
    nextColumnIdx: PropTypes.number.isRequired,
    canvasBlocks: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    selectedBlocks: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect(mapStateToProps)(Column);
